import React, { useEffect, useState, useRef } from 'react';
import styles from '../styles.module.scss';
import { formatPrice } from '@utils/utils';
import { SliderInput } from '@lion-design/liontravel';

export interface IBarProps {
    Currency: string; // 幣別
    minPrice: number; // 最小價錢 ex: 0
    maxPrice: number; // 最大價錢 ex: 99999
    setRange: number[]; // 設定bar目前要拉到哪個位置 ex:[3333, 55555]
    mouseupChange: (value: number[], onDragBtn: string) => void; // 放開拉霸觸發
}

const PriceRangeItem: React.FC<IBarProps> = (props) => {
    const moduleName = 'priceBar';
    const { Currency, minPrice, maxPrice, setRange, mouseupChange } = props;
    const [price, setPrice] = React.useState([setRange[0], setRange[1]]);
    const [btnType, setbtnType] = React.useState('');
    const setFormatPrice = true; // 判斷是否將價格數字每千分位逗號隔開

    // 判斷filterTag點擊重設條件 重設最大最小值
    React.useEffect(() => {
        if (setRange[0] === minPrice && setRange[1] === maxPrice) {
            setbtnType('clear');
            setPrice(setRange);
        }
    }, [setRange[0], setRange[1]]);

    // 判斷價格變動觸發filterTag-function
    React.useEffect(() => {
        btnType !== '' && btnType !== 'clear' && mouseupChange(price, btnType);
    }, [price[0], price[1]]);

    const updatePrice = (newPrice: number[], type: string) => {
        if (price[0] === newPrice[0] && price[1] === newPrice[1]) return; // 數值相同不執行 否則input框為0時點擊會無法修改
        setbtnType(type);
        setPrice(newPrice);
    };

    const sliderOnClick = (newPrice: number[], type: string) => {
        setbtnType(type);
        setPrice(newPrice);
    };

    return (
        <div className={styles[`${moduleName}`]}>
            <SliderInput
                currency={Currency}
                minPrice={minPrice}
                maxPrice={maxPrice}
                setRange={price}
                setFormatPrice={setFormatPrice}
                updatePrice={updatePrice}
                sliderOnClick={sliderOnClick}
            />
        </div>
    );
};

export default PriceRangeItem;
